export const isDefined = (value: any) => typeof value !== 'undefined';

export class BaseModel {}
